// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import api from "@src/api/config"
import { showModalSuccess } from "../../../../redux/modalTypeSuccess"
// import { showModalSuccess } from "../../../../redux/modalTypeSuccess"
// import { hideModalCustom } from "../../../../redux/modalTypeCustom"

const urlBase = "api/electronic_equipment"

const initialState = {
    data: [],
    suggestions: [],
    // defaultValues: {},
    currentPage: 1,
    params: {}, // all filters
    meta: {},
    total: 0,
    rowsPerPage: 10,
    loading: false,
    electronicEquipment: {},
    electronicEquipmentOptions: []
  }

export const getElectronicEquipments = createAsyncThunk(
  "electronicEquipments/get",
  async (params, {getState}) => {
    const state = getState()
    const { productSelected } = state.products
    params.product = productSelected?.value
    const response = await api.get(`${urlBase}`, { params })
    return {
      params,
      data: response.data
    }
  }
)

export const getElectronicEquipmentById = createAsyncThunk(
  "electronicEquipments/getById",
  async (id) => {
    const response = await api.get(`api/electronic_equipment/${id}`)
    return {
      data: response.data
    }
  }
)

export const createElectronicEquipments = createAsyncThunk("electronicEquipments/store", async (payload = {}, {getState, dispatch}) => {
  const state = getState()
  const { productSelected } = state.products
  payload.product = productSelected?.value
  const response = await api.post(`${urlBase}`, payload)

  // success handler
  if (response.data.status === 'success') {
    if (payload.from === 'providers') dispatch(getElectronicEquipments({ format: "options" }))
    dispatch(showModalSuccess(payload.from === 'providers' ? {message: response.data.message} : {message: response.data.message, url: 'goBack'}))
  }

  return {
    data: response.data
  }
})

export const getElectronicEquipmentsSuggestion = createAsyncThunk(
  "electronicEquipments/getSuggestion",
  async (params, {getState}) => {
    const state = getState()
    const { productSelected } = state.products
    params.product = productSelected?.value
    const response = await api.get('api/electronic_equipment/suggestions', { params })
    return {
      params,
      data: response.data
    }
  }
)

export const updateElectronicEquipment = createAsyncThunk(
  "electronicEquipments/update",
  async ({id, payload}, {dispatch}) => {
    const response = await api.put(`api/electronic_equipment/${id}`, payload)

    // success handler
    if (response.data.status === 'success') {
      dispatch(showModalSuccess({message: response.data.message, url: 'goBack'}))
    }

    return {
      data: response.data
    }
  }
)

export const deleteElectronicEquipment = createAsyncThunk(
  "electronicEquipments/destroy",
  async (id, {dispatch}) => {
    const response = await api.delete(`api/electronic_equipment/${id}`)

    // success handler
    if (response.data.status === 'success') {
      dispatch(showModalSuccess({message: response.data.message, url: '/catalogs/electronic_equipment'}))
      dispatch(getElectronicEquipments({page: 1}))
    }

    return {
      data: response.data
    }
  }
)

export const electronicEquipmentsSlice = createSlice({
  name: "electronicEquipments",
  initialState,
  reducers: {
    //
  },
  extraReducers: (builder) => {
    builder.addCase(getElectronicEquipments.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getElectronicEquipments.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getElectronicEquipments.fulfilled, (state, action) => {
      state.loading = false
      if (action.payload?.params?.format === 'options') {
        state.electronicEquipmentOptions = action.payload.data
      } else {
        state.data = action.payload.data.data
        state.currentPage = action.payload.data.meta.current_page
        state.params = action.payload.params
        state.meta = action.payload.data.meta
        state.total = action.payload.data.meta.total
        state.rowsPerPage = action.payload.data.meta.per_page
      }
    })
    builder.addCase(getElectronicEquipmentsSuggestion.fulfilled, (state, action) => {
      state.suggestions = action.payload.data
    })
    builder.addCase(getElectronicEquipmentById.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getElectronicEquipmentById.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getElectronicEquipmentById.fulfilled, (state, action) => {
      state.loading = false
      state.electronicEquipment = action.payload.data.data
    })
  }
})


export default electronicEquipmentsSlice.reducer
